import BookIcon from '@mui/icons-material/MenuBookRounded';
import ChatIcon from '@mui/icons-material/ChatRounded';
import SwapIcon from '@mui/icons-material/SwapHorizRounded';
import SummaryCard from './SummaryCard';
import styled from 'styled-components';

const Container = styled.div`
  width: 100%;
  display: flex;
  gap: 8px;
`

const SummaryCardList = ({ data }) => {
  const summaryData = [
    { id: 'wordCount', label: '단어 수', unit: '개', icon: BookIcon, color: '#6FDC8A' },
    { id: 'conversationCount', label: '대화 수', unit: '개', icon: ChatIcon, color: '#FF8F8F'},
    { id: 'averageTurn', label: '평균 턴 수', unit: '회', icon: SwapIcon, color: '#FFC83D' },
  ]

  return (
    <Container>
      {summaryData.map((item) => (
        <SummaryCard 
          key={item.id} 
          value={data[item.id]}
          {...item}/>
      ))}
    </Container>
  )
}

export default SummaryCardList
